import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {InputFileComponent} from "./input-file.component";
import {ButtonModule} from "../button/button.module";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [ InputFileComponent ],
  imports: [ CommonModule, ButtonModule, TranslateModule ],
  exports: [ InputFileComponent ],
})
export class InputFileModule {}
